import isArray from './is-array.js';
import isArrayOfObjects from './is-array-of-objects.js';
import isDate from './is-date.js';
import isFalsey from './is-falsey.js';
import isISODate from './is-iso-date.js';
import isMDY from './is-mdy.js';
import isNull from './is-null.js';
import isNumber from './is-number.js';
import isNumericalString from './is-numerical-string.js';
import isObject from './is-object.js';
import isString from './is-string.js';
import isTruthy from './is-truthy.js';
import isUndefined from './is-undefined.js';
import isYMD from './is-ymd.js';

/**
 * @func checkTypeValidity
 * @param value - the input to be checked
 * @param arrayOfKeys - an array of acceptible value types
 * @return {boolean}
 * @desc Checks that the value given is of one of the acceptible types in the array
 *```js
 * checkTypeValidity(['number', 'string'], 9);
 * // returns true
 *
 * checkTypeValidity(['number'], 'hi there');
 * // logs a console warning 'invalid type'
 * //returns false
 *```
 * @memberof module:TypeCheck
 * @instance
 */
const typeCheckers = {
    array: isArray,
    arrayOfObjects: isArrayOfObjects,
    date: isDate,
    falsey: isFalsey,
    isoDate: isISODate,
    MDY: isMDY,
    null: isNull,
    number: isNumber,
    numericalString: isNumericalString,
    object: isObject,
    string: isString,
    truthy: isTruthy,
    undefined: isUndefined,
    YMD: isYMD,
};
function checkTypeValidity(arrayOfKeys, value) {
    if (arrayOfKeys.some((key) => typeCheckers[key](value) === true)) {
        return true;
    }
    else {
        // eslint-disable-next-line no-console
        console.warn(`warbler: invalid type - expected one of type: ${arrayOfKeys.join(',')}`);
        return false;
    }
}

export { checkTypeValidity as default };
